module.exports = __webpack_public_path__ + "assets/21b9e0f75b5cb0cde90e8b57875ff6a1.png";